import { ACCOUNT_COOKIE_NAME, ACCOUNT_NOTIFICATION_TYPE } from './constants';
import { deleteCookie, getCookie, setCookie } from '../../common/services/cookies.service';
import React from 'react';
import notificationsEvents from '../../notifications/data/notifications.events';
import AccountBaseBanner from '../components/AccountBaseBanner';
import {Translations} from "../../common/models/common.models";
import {Notification, NotificationsConfig} from "../../notifications/data/models";

let translations: Translations;
let cookieDomain: string;
let onReadyCallback: Function;

const addOnReadyCallback = (callback: Function) => {
    onReadyCallback = callback;
};

const initService = (data: {translations: Translations}, domain: string) => {
    translations = data.translations;
    cookieDomain = domain;
    if (typeof onReadyCallback === 'function') onReadyCallback();
};

const clearAccountCookies = () => {
    Object.values(ACCOUNT_COOKIE_NAME).forEach(cookieName => deleteCookie(cookieName, cookieDomain));
};

const getAccountCookieCounter = (type: ACCOUNT_NOTIFICATION_TYPE) => {
    return getCookie(ACCOUNT_COOKIE_NAME[type]) || 0;
};

const setAccountNotificationDisplayed = (type: ACCOUNT_NOTIFICATION_TYPE, cookieCounter = 1) => {
    setCookie(ACCOUNT_COOKIE_NAME[type], cookieCounter, 14, cookieDomain);
};

const getNotificationsConfig = (cookieCounter = 1): NotificationsConfig => {
    return {
        EXPIRED: {
            notificationType: ACCOUNT_NOTIFICATION_TYPE.EXPIRED,
            importance: cookieCounter,
            MessageComponent: () => (
                <AccountBaseBanner
                    contactUsText={translations.TI2020_ContentTranslations_Header_expired_contact_us_description}
                    startText={
                        translations.TI2020_ContentTranslations_Header_expired_your_subscription +
                        ' ' +
                        translations.TI2020_ContentTranslations_Header_expired_please
                    }
                    linkText={translations.TI2020_ContentTranslations_Header_expired_contact_us}
                    endText={translations.TI2020_ContentTranslations_Header_expired_to_renew}
                />
            ),
            onDismiss: () => setAccountNotificationDisplayed(ACCOUNT_NOTIFICATION_TYPE.EXPIRED, cookieCounter),
        },
        ALMOST_EXPIRED: {
            notificationType: ACCOUNT_NOTIFICATION_TYPE.ALMOST_EXPIRED,
            importance: cookieCounter,
            MessageComponent: () => (
                <AccountBaseBanner
                    contactUsText={translations.TI2020_ContentTranslations_Header_almost_expired_contact_us_description}
                    startText={
                        translations.TI2020_ContentTranslations_Header_almost_expired_your_subscription +
                        ' ' +
                        translations.TI2020_ContentTranslations_Header_almost_expired_please
                    }
                    linkText={translations.TI2020_ContentTranslations_Header_almost_expired_contact_us}
                    endText={translations.TI2020_ContentTranslations_Header_almost_expired_to_renew}
                />
            ),
            onDismiss: () => setAccountNotificationDisplayed(ACCOUNT_NOTIFICATION_TYPE.ALMOST_EXPIRED, cookieCounter),
        },
        LOW_BALANCE: {
            notificationType: ACCOUNT_NOTIFICATION_TYPE.LOW_BALANCE,
            importance: cookieCounter,
            MessageComponent: () => (
                <AccountBaseBanner
                    contactUsText={translations.TI2020_ContentTranslations_Header_low_balance_contact_us_description}
                    startText={
                        translations.TI2020_ContentTranslations_Header_low_balance_running_low +
                        ' ' +
                        translations.TI2020_ContentTranslations_Header_low_balance_please
                    }
                    linkText={translations.TI2020_ContentTranslations_Header_low_balance_contact_us}
                    endText={translations.TI2020_ContentTranslations_Header_low_balance_to_renew}
                />
            ),
            onDismiss: () => setAccountNotificationDisplayed(ACCOUNT_NOTIFICATION_TYPE.LOW_BALANCE, cookieCounter),
        },
    };
};

const handleNewNotifications = (notifications: Notification[], cookieCounterOverride = 1) => {
    const data: Notification[] = [];
    const config = getNotificationsConfig(cookieCounterOverride);
    notifications &&
        notifications.forEach(({ notificationType }) => {
            const isNotificationDisplayed = getAccountCookieCounter(ACCOUNT_NOTIFICATION_TYPE[notificationType]);
            if (Number(isNotificationDisplayed) < cookieCounterOverride) data.push(config[notificationType]);
        });
    if (data.length) notificationsEvents.addBanner(data);
};

export default {
    clearAccountCookies,
    getAccountCookieCounter,
    setAccountNotificationDisplayed,
    handleNewNotifications,
    initService,
    addOnReadyCallback,
};
